import { EVENT_KEYS } from 'presentation/events';
import { createRequesterMediator } from '../utils';

export const mediateLoginRequester = (loginRequestSignal, dispatch) => {
    const handleSignal = (payload) => {
        dispatch({
            type : EVENT_KEYS.LOGIN,
            payload
        });
    };
    return createRequesterMediator({ signalHandler : handleSignal })(loginRequestSignal);
};
